import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Globe, Zap, Shield, Terminal, Rocket, Layers } from 'lucide-react';

export default function SolutionDeployment() {
  return (
    <SubpageTemplate 
      title="Global Deployment"
      subtitle="The Edge Engine"
      description="Yacht Labs handles the heavy lifting of infrastructure. One click sends your build to the global edge with built-in security and scaling."
      icon={Globe}
      features={[
        {
          title: "Edge Runtime",
          description: "Lightning-fast performance with deployments that live as close to your users as possible.",
          icon: Zap
        },
        {
          title: "Secure Rails",
          description: "Automated SSL, DDoS protection, and secure data handling out of the box.",
          icon: Shield
        },
        {
          title: "CI/CD Synthesis",
          description: "Continuously update your live builds with a seamless automated pipeline.",
          icon: Layers
        }
      ]}
    />
  );
}
